import React from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import styles from './styles.module.scss'

interface IProps {
  icon: IconProp
  size?: FontAwesomeIconProps['size']
  className?: string
}

export const CircleIcon: React.FC<IProps> = ({ icon, size, className = '' }) => {
  return (
    <div className={styles.circle}>
      <div className={styles.square}>
        <FontAwesomeIcon className={`${styles.icon} ${className}`} icon={icon} size={size} />
      </div>
    </div>
  )
}
